import { connect } from 'react-redux';

import { favoritePodcastToggle } from 'actions/favoritePodcast-actions';
import { openFold, closeFold } from 'actions/podcastFold-actions';
import { getIsOpen, getPodcast } from 'store/reducers/podcastFold';
import { getIsFavoritePodcast } from 'store/reducers/favorites';

import { getUserSearch } from 'store/reducers/search';
import { saveRecentSearch } from 'actions/search-actions';
import { State } from 'redux';
import PodcastTile, { PodcastTileProps } from './PodcastTile';
import { Podcast } from 'api/models';

const mapStateToProps = (state: State, ownProps: PodcastTileProps) => ({
  foldIsOpen: !!getIsOpen(state),
  isFavorite: getIsFavoritePodcast(state, ownProps),
  podcastSlugInFold: getPodcast(state),
  userSearched: getUserSearch(state),
});

const mapDispatchToProps = {
  closeFold,
  onFavoriteToggle: (podcast: Podcast) => favoritePodcastToggle(podcast),
  openFold,
  saveRecentSearch,
};

export default connect(mapStateToProps, mapDispatchToProps)(PodcastTile);
